// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__X3xnv","loader__spinner":"Loader_loader__spinner__lNm6B","spin":"Loader_spin__r0+yH"};